import { Pipe, PipeTransform } from '@angular/core';

/**
 * A pipe which transforms a numeric value of degrees Fahrenheit into the equivalent numeric value of degrees Celsius.
 * For example, the value `98.6` would be transformed into the value `37`, as 98.6°F is equivalent to 37.0°C.
 */
@Pipe({
  name: 'toCelsius'
})
export class ToCelsiusPipe implements PipeTransform {
  /**
   * A pipe which transforms a numeric value of degrees Fahrenheit into the equivalent numeric value of degrees Celsius.
   * For example, the value `98.6` would be transformed into the value `37`, as 98.6°F is equivalent to 37.0°C.
   * @param fahrenheitValue the temperature value in Fahrenheit
   * @returns the equivalent temperature value in Celsius
   */
  transform(fahrenheitValue: number): number {
    /** convert the Fahrenheit value into its exact equivalent Celsius value */
    return (fahrenheitValue - 32) * 5 / 9;
  }

}
